import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=11b9d4d5&scoped=true&"
import script from "./InputTel.ts?vue&type=script&lang=ts&"
export * from "./InputTel.ts?vue&type=script&lang=ts&"
import style0 from "./InputTel.scss?vue&type=style&index=0&id=11b9d4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b9d4d5",
  null
  
)

export default component.exports